<template>
  <!-- eslint-disable  -->
  <div class="w-100">
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0 background-white" style="z-index: 10;">
      <interview-navi :navData="pageData"></interview-navi>
    </div>
    <div class="container page-wrap" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus}">
      <div id="nonendtoend" class="row no-gutters mx-0 my-3 justify-content-center" v-if="getHomeCarrier && isBothNonEndToEnd">
        <div class="col-10 non-end-to-end-col py-4 px-5">
          <div class="row mb-4">
            <div class="col-12 msg-col text-center">
              <img :src="getHomeCarrier.logoPathSvg" class="mb-3 carrier-logo">
              <p>Please continue to the <strong>{{ getHomeCarrier.carrier_name }}&#39;s</strong> agent platform in a new browser tab to complete the purchase of this {{ flow }} policy.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 btn-col text-center">
              <button :disabled="isButtonDisable('home')" type="button" tabindex="0" class="btn btn-primary select-carrier-btn mb-2" @click="continueToHomeCarrier()" role="button">
                CONTINUE TO {{ getHomeCarrier.carrier_name }}
                <i class="fa fa-open-in-new ml-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z" fill="currentColor"/>
                  </svg>
                </i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="nonendtoend" class="row no-gutters mx-0 my-3 justify-content-center">
        <div class="col-10 non-end-to-end-col py-4 px-5">
          <div class="row mb-4">
            <div class="col-12 msg-col text-center">
              <img :src="getSrc" class="mb-3 carrier-logo">
              <p><span v-if="checkBundleCarriers">1.&nbsp;</span>Please continue to the <strong>{{ getCarrierName }}&#39;s</strong> agent platform in a new browser tab to complete the purchase of this {{ carrierType }} policy.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 btn-col text-center">
              <button :disabled="isButtonDisable('other')" type="button" tabindex="0" class="btn btn-primary select-carrier-btn mb-2" @click="continueToSelectedCarrier()" role="button">
                CONTINUE TO {{ getCarrierName}}
                <i class="fa fa-open-in-new ml-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z" fill="currentColor"/>
                  </svg>
                </i>
              </button>
            </div>
          </div>
          <div class="row mt-4" v-if="checkBundleCarriers">
            <div class="col-12 msg-col text-center">
              <p v-html="second_msg_line"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 text-center bottom-msg-line">
          <p>All of your quote information has been saved in QRP Agent Portal.</p>
          <p v-if="!checkBundleCarriers" class="mt-4">Go to the Search Results page to begin a new quote.</p>
        </div>
      </div>
      <div class="form-row justify-content-center mx-0" v-if="checkBundleCarriers">
        <div class="col-10 text-center py-3">
          <button type="submit" class="btn btn-primary btn"
            @click.prevent="endToEndSubmitted">{{ submitButtonLabel }}
            <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g id="&#240;&#159;&#166;&#134; icon &#34;arrow-right-thick&#34;">
              <path id="Vector" d="M4.5 10.0001V14.0001H13.5L10 17.5001L12.42 19.9201L20.34 12.0001L12.42 4.08008L10 6.50008L13.5 10.0001H4.5Z" fill="currentColor"/>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!-- Bound Policy Alert -->
    <form-alerts v-if="isBothFlowBound" :pageData="policyBindError" :class="{'policy-bound-alert': true, 'margin-25' : quotePanelStatus}"></form-alerts>
  </div>
</template>

<script>
/* eslint-disable */
import { pageMixin } from '../../../mixins/pageMixin';
import InterviewNavigation from './Navigation';
import FormAlerts from '../../presentational/alerts/FormAlerts.vue';
import fetchData from '../../../services/fetchData';

export default {
  mixins: [pageMixin],
  data() {
    return {  
      flowType: '',    
      pageData: {
        page_name: '',
        buttons: [],
        fields: [],
        blurbs: [],
        quote_summary: {},
      },
      carrierType: 'Auto',
      second_msg_line: '2. Then click <strong>"CONTINUE TO HOME CHECKOUT ⮕"</strong> to complete the policy purchase with QRP&#39;s Agent Portal.',
      flow : 'Home',
    };
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');
    let sessionID = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
    const rateRequestParams = {
      url: `/pages/carriermatches/${sessionID}`,
    };
    fetchData.getPageData(rateRequestParams).then((response) => {
      // this.pageData = response.data;
    })      
  },
  components: {
    interviewNavi: InterviewNavigation,
    FormAlerts,
  },
  computed: {
    isBothFlowBound() {
      let autoCarrierType = sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type : '';
      let homeCarrierType = sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type : ''; 
      if (autoCarrierType === 'EZLYNXCARRIER' && homeCarrierType === 'EZLYNXCARRIER' && sessionStorage.getItem('homebound') == 'true' && sessionStorage.getItem('autobound') == 'true') {
        return true;
      } else if (autoCarrierType !== 'EZLYNXCARRIER' && homeCarrierType === 'EZLYNXCARRIER' && sessionStorage.getItem('homebound') == 'true') {
        return true;
      } else if (homeCarrierType !== 'EZLYNXCARRIER' && autoCarrierType === 'EZLYNXCARRIER' && sessionStorage.getItem('autobound') == 'true') {
        return true;
      }      
      return false;
    },
    isBothCarrierSelected() {
      return this.getHomeCarrier && this.getAutoCarrier;
    },
    isBothNonEndToEnd() {
      let autoCarrierType = this.getAutoCarrier ? this.getAutoCarrier.carrier_type : '';
      let homeCarrierType = this.getHomeCarrier ? this.getHomeCarrier.carrier_type : '';
      if (this.flowType === 'cabundle') {
        this.flow = 'Condo';
      } else if (this.flowType === 'rabundle') {
        this.flow = 'Renters';
      }
      return (autoCarrierType === 'EZLYNXCARRIER' && homeCarrierType === 'EZLYNXCARRIER');
    },
    getHomeCarrier() {
      return sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')) : '';
    },
    getAutoCarrier() {
      return sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')) : '';
    },
    checkBundleCarriers() {
      let homeCarrierType = this.getHomeCarrier ? this.getHomeCarrier.carrier_type : '';
      let autoCarrierType = this.getAutoCarrier ? this.getAutoCarrier.carrier_type : '';
      if(!this.isBothCarrierSelected) {
      // if ((homeCarrierType === 'EZLYNXCARRIER' && !sessionStorage.getItem('selectedCarrierAuto')) || (autoCarrierType === 'EZLYNXCARRIER' && !sessionStorage.getItem('selectedCarrierHome'))) {
        return false;
      } 
      if (homeCarrierType === 'EZLYNXCARRIER' && autoCarrierType === 'EZLYNXCARRIER' && this.$router.currentRoute.path === '/auto/non-end-to-end') {
        return false;
      } 
      return true;
    },
    submitButtonLabel() {
      if (this.$router.currentRoute.path === '/home/non-end-to-end') {
        this.carrierType = "Home";
        this.second_msg_line = '2. Then click <strong>"CONTINUE TO AUTO FLOW ⮕"</strong> to complete the Auto policy purchase with QRP&#39;s Agent Portal.';
        return 'continue to auto Flow';
      } else if (this.$router.currentRoute.path === '/condo/non-end-to-end') {
        this.carrierType = "Condo";
        this.second_msg_line = '2. Then click <strong>"CONTINUE TO AUTO FLOW ⮕"</strong> to complete the Auto policy purchase with QRP&#39;s Agent Portal.';
        return 'continue to auto Flow';
      } else if (this.$router.currentRoute.path === '/renters/non-end-to-end') {
        this.carrierType = "Renters";
        this.second_msg_line = '2. Then click <strong>"CONTINUE TO AUTO FLOW ⮕"</strong> to complete the Auto policy purchase with QRP&#39;s Agent Portal.';
        return 'continue to auto Flow';
      }
      return this.getAutoCarrier && this.getAutoCarrier.carrier_type === 'EZLYNXCARRIER' ? 'continue to Home Checkout' : 'continue to Checkout';
    },
    getCarrierName() {
      let carrierName = '';
      if (this.$router.currentRoute.path === '/home/non-end-to-end' || this.$router.currentRoute.path === '/condo/non-end-to-end' || this.$router.currentRoute.path === '/renters/non-end-to-end') {
        carrierName = this.getHomeCarrier ? this.getHomeCarrier.carrier_name : '';
      } else {
        carrierName = this.getAutoCarrier ? this.getAutoCarrier.carrier_name : '';
      }
      return carrierName;
    },
    getSrc() {
      let logoSrc = ''
      if (this.$router.currentRoute.path === '/home/non-end-to-end' || this.$router.currentRoute.path === '/condo/non-end-to-end' || this.$router.currentRoute.path === '/renters/non-end-to-end') {
        logoSrc = this.getHomeCarrier ? this.getHomeCarrier.logoPathSvg : '';
      } else {
        logoSrc = this.getAutoCarrier ? this.getAutoCarrier.logoPathSvg : '';
      }
      return logoSrc;
    },
  },
  methods: {
    isButtonDisable(type) {
      if (type === 'home') {
          return sessionStorage.getItem('homebound') == 'true';
      } else {
        if (this.$router.currentRoute.path === '/home/non-end-to-end' || this.$router.currentRoute.path === '/condo/non-end-to-end' || this.$router.currentRoute.path === '/renters/non-end-to-end') {
          return sessionStorage.getItem('homebound') == 'true'
        } else {
          return sessionStorage.getItem('autobound') == 'true';
        }
      }
    },
    continueToHomeCarrier() {
      let externalUrl = this.getHomeCarrier ? this.getHomeCarrier.external_url : ''
      
      if (externalUrl) {
        window.open('#','_blank');window.open(externalUrl,'_self');
      }

    },
    continueToSelectedCarrier() {
      let externalUrl = '';
      if (this.$router.currentRoute.path === '/home/non-end-to-end' || this.$router.currentRoute.path === '/condo/non-end-to-end' || this.$router.currentRoute.path === '/renters/non-end-to-end') {   
        externalUrl = this.getHomeCarrier ? this.getHomeCarrier.external_url : '';
      } else {
        externalUrl = this.getAutoCarrier ? this.getAutoCarrier.external_url : '';
      }
      if (externalUrl) {
        window.open('#','_blank');window.open(externalUrl,'_self');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .quote-panel-open {
    margin: 0;
    width: 75%;
    -webkit-transition: width 500ms;
    transition: width 500ms;
  }
  .quote-panel-close {
    width: 100%;
    -webkit-transition: width 500ms;
    transition: width 500ms;
  }
  .page-wrap {
    margin-top: 9em;
  }
  .non-end-to-end-col {
    border: 1px solid #CCCCCC;
    border-radius: 8px;
    .row {
      max-width: 600px;
      margin: 0 auto;
    }
  }
  p {
    color: #000;
    text-align: left;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 21px;
    margin: 0;
  }
  .carrier-logo {
    max-width: 200px;
  }
  .btn-primary.select-carrier-btn {
    .fa-open-in-new {
      font-size: 12px;
    }

    background-color: #FFFFFF;
    border-color: $var-color-home-auto-bundle;
    color: $var-color-home-auto-bundle;

    &:hover {
      background-color: $var-color-home-auto-bundle;
      border-color: #FFFFFF;
      color: #FFFFFF;
      .fa-open-in-new {
        color: #FFFFFF;
      }
      svg {
        position: relative;
        top: -1px;
      }
    }

    &:disabled {
      // pointer-events: not-allowed;
      cursor: not-allowed;
    }
  }
  .form-row {
    background: #F9F9F9;
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.14);
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
  }
  .bottom-msg-line p {
    color: #000;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/interview/shared/NonEndToEnd.vue?77e358ab